import React from 'react';
import { Button } from 'antd';
import {
  BellOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  ToolOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { navigateToApprovalCenter, navigateToLink, isApprovalCenterLink } from '../../utils/approvalCenterNav';
import './ApprovalNotifyBanner.css';

const TYPE_LABEL = {
  approve: '待审批',
  cc: '抄送',
  execute: '待执行',
  return: '已退回',
  finished: '已通过',
  rejected: '已驳回'
};

const TAB_BY_NOTIFY_TYPE = {
  approve: 'todo',
  cc: 'cc',
  execute: 'execute',
  return: 'initiated',
  finished: 'initiated',
  rejected: 'initiated'
};

const VARIANT_BY_NOTIFY_TYPE = {
  approve: 'pending',
  execute: 'execute',
  cc: 'info',
  return: 'warning',
  finished: 'success',
  rejected: 'rejected'
};

function resolveNotifyLink(item) {
  const raw = item?.link_path || '';
  if (raw.includes('tab=')) return raw;
  const tab = TAB_BY_NOTIFY_TYPE[item?.notify_type];
  if (tab) return `/approval-center?tab=${tab}`;
  return raw || '/approval-center?tab=todo';
}

function renderIcon(notifyType, variant) {
  if (variant === 'success') return <CheckCircleOutlined />;
  if (variant === 'rejected') return <CloseCircleOutlined />;
  if (notifyType === 'execute') return <ToolOutlined />;
  return <BellOutlined />;
}

function shouldShowContent(item) {
  if (['approve', 'execute'].includes(item.notify_type)) return false;
  return Boolean(item.content);
}

const ApprovalNotifyBanner = ({ items, onDismiss, onDismissAll }) => {
  const navigate = useNavigate();

  if (!items?.length) return null;

  return (
    <div className="approval-notify-stack">
      {items.map((item) => {
        const variant = VARIANT_BY_NOTIFY_TYPE[item.notify_type] || 'pending';
        const showContent = shouldShowContent(item);

        return (
          <div
            key={item.id}
            className={`approval-notify-banner approval-notify-banner--${variant}`}
          >
            <button
              type="button"
              className="approval-notify-close"
              aria-label="关闭"
              onClick={() => onDismiss(item.id)}
            >
              <CloseOutlined />
            </button>

            <div className="approval-notify-main">
              <div className="approval-notify-icon">
                {renderIcon(item.notify_type, variant)}
              </div>
              <div className="approval-notify-body">
                <div className="approval-notify-tag">{TYPE_LABEL[item.notify_type] || '提醒'}</div>
                <div className="approval-notify-title">{item.title}</div>
                {showContent && (
                  <div className="approval-notify-content">{item.content}</div>
                )}
              </div>
            </div>

            <div className="approval-notify-footer">
              <Button
                size="small"
                className="approval-notify-detail-btn"
                onClick={() => {
                  onDismiss(item.id);
                  const link = resolveNotifyLink(item);
                  if (isApprovalCenterLink(link)) {
                    navigateToApprovalCenter(navigate, link, {
                      taskId: item.task_id,
                      tab: TAB_BY_NOTIFY_TYPE[item?.notify_type]
                    });
                    return;
                  }
                  navigateToLink(navigate, link);
                }}
              >
                详情
              </Button>
            </div>
          </div>
        );
      })}
      {items.length > 1 && (
        <button type="button" className="approval-notify-dismiss-all" onClick={onDismissAll}>
          全部关闭
        </button>
      )}
    </div>
  );
};

export default ApprovalNotifyBanner;
